export const createPathname = (pathname: string, basePath?: string, locale?: string) => {
  let nextPathname = pathname
  if (!nextPathname.startsWith('/')) {
    nextPathname = `/${nextPathname}`
  }

  if (nextPathname === '/') {
    nextPathname = ''
  }

  if (!!basePath && !nextPathname.toLowerCase().includes(basePath.toLowerCase())) {
    nextPathname = `${basePath.toLowerCase()}${nextPathname}`
  }
  if (!!locale && !nextPathname.toLowerCase().includes(locale.toLowerCase())) {
    nextPathname = `/${locale}${nextPathname}`
  }

  return nextPathname || '/'
}
